let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8WF7X")).then(() => parcelRequire('2sEmv'));